import { Component } from '@angular/core';
import { ProfileService } from '../profile/profile.service';
import { ROUTER_DIRECTIVES } from '@angular/router';
import { Router } from '@angular/router';

declare const jQuery: any;

@Component({
    selector: 'profile',
    template: require('.//profile.component.html'),
    directives: [ROUTER_DIRECTIVES],
    providers: [ProfileService]
})

export class ProfileComponent {

    private data: any;
    private data1: any;
    private data2: any;
    private posts: any = [];
    private token: any;
    private loading = true;
    username: any;
    commnentdetails: any = [];


    constructor(private _profileService: ProfileService, private _router: Router) {


    }
    private offset = 0;
    private loadmoree: any;
    private userprofile_name: any;
    totaldata: any;
    commentdata: any;
    submitComment: any;

    ngOnInit() {
        jQuery(".modal-backdrop").css({ "display": "none" });
        //  this.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoia2FseWFuIiwiZW1haWwiOiJ2YW1zaUBnbWFpbC5jb20iLCJpYXQiOjE0NzAyOTg2MjcsImV4cCI6MTQ3NTQ4MjYyN30.ZYzOydphDJNr5EPeKNsDP0bxjFSAseyeo_yBBudaxz8';
        var username = localStorage.getItem('username');
        this.username = username;
        var token = localStorage.getItem('authToken');
        if (!token)
            this._router.navigate(["login"]);
        var username = localStorage.getItem('username');
        this.userprofile_name = username;

        this._profileService.profile()
            .subscribe((res) => {
                if (res.code == 9200) {
                    var token = localStorage.removeItem('authToken');
                    var username = localStorage.removeItem('username');
                    this._router.navigate(['login']);
                }
                this.loading = false;
                this.data = res.memberProfileData[0];
                /** bio add tag**/
                var biotext = this.data.bio;
                if (biotext) {
                    var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
                    var bio_detail = biotext.replace(
                        hashtag_regexp,
                        '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>'
                    );
                    // this.data.bio =bio_detail;

                    // var biotext1 = this.data.bio;
                    var hashtag_regexpp = /@([a-zA-Z0-9_]+)/g;
                    var bio_detaill = bio_detail.replace(
                        hashtag_regexpp,
                        '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>'
                    );
                }
                this.data.bio = bio_detaill;

                // this.posts = res.data[1];
                this.posts = [];
                this.totaldata = res.memberPostsData;
                // var commenttext = res.memberPostsData.comments;               
                this.offset = res.memberPostsData.length;

                this.commentfunction();
                // console.log(this.offset);
                if (this.offset >= 20)
                    this.loadmoree = true;
            });

        this._profileService.userFollowing()
            .subscribe((res) => {
                this.data1 = res.result;
                this.loading = false;
            });

        this._profileService.userFollowers()
            .subscribe((res) => {
                this.data2 = res.followers;
                this.loading = false;
            });
        jQuery(document).keyup(function (e: any) {
            if (e.keyCode == 27) {
                jQuery(".modal").css({ "display": "none" });
                jQuery(".modal-backdrop").css({ "display": "none" });
            }
        });

    }

    hashtagFunction() {
        var len = this.totaldata.length;
        for (var i = 0; i < len; i++) {
            if (this.totaldata[i].commentData) {
                var commenttext = this.totaldata[i].commentData;
                for (var x = 0; x < commenttext.length; x++) {
                    // commenttext.splice(x, 0);
                    if (this.totaldata[i].commentData[x].commentBody) {
                        var postCommentNodeArr1 = commenttext[x].commentBody;
                        // console.log(postCommentNodeArr1);
                        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
                        var comment_text = postCommentNodeArr1.replace(
                            hashtag_regexp,
                            '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>'
                        );
                        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
                        var comment_textt = comment_text.replace(
                            hashtag_regexp1,
                            '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>'
                        );
                        this.totaldata[i].commentData[x].commentBody = comment_textt;
                    }
                }
            }
        }
    }


    commentfunction() {
        this.hashtagFunction();
        // alert("hi");
        var len = this.totaldata.length;
        // this.posts=[];
        for (var i = 0; i < len; i++) {
            // this.commentdata = [];
            // if (this.totaldata[i].comments) {

            //     var commenttext = this.totaldata[i].comments;
            //     var hashtag_regexp = /#([a-zA-Z0-9]+)/g;                
            //     var comment_text = commenttext.replace(
            //         hashtag_regexp,
            //         '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>' 
            //     );

            //     var hashtag_regexp1 = /@([a-zA-Z0-9]+)/g;                
            //     var comment_textt = comment_text.replace(
            //         hashtag_regexp1,
            //         '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>' 
            //     );

            //     var postCommentNodeArr = comment_textt.split('^^');
            //     for (var x = 0; x < postCommentNodeArr.length; x++) {
            //         postCommentNodeArr.splice(x, 0);
            //         var postCommentNodeArr1 = postCommentNodeArr[x].split('$$');
            //         if (postCommentNodeArr1.length == 2)
            //         this.commentdata.push(postCommentNodeArr1);
            //     }
            // }
            // this.totaldata[i].comments = this.commentdata;           

            var postCaption: any = [];
            if (this.totaldata[i].postCaption) {
                var postCaptionn = this.totaldata[i].postCaption.split(' ');
                this.totaldata[i].postCaption = postCaptionn;
            }
            var postLikedBy: any = [];
            if (this.totaldata[i].postLikedBy) {
                var liked = this.totaldata[i].postLikedBy.split(',');
                if (liked.length) {
                    this.totaldata[i].postLikedBy = liked;
                }
            } else {
                this.totaldata[i].postLikedBy = [];
            }

            var usersTagged: any = [];
            if (this.totaldata[i].usersTagged) {
                usersTagged = this.totaldata[i].usersTagged.split(',');
                this.totaldata[i].usersTagged = usersTagged;
            }

            var taggedUserCoordinates: any = [];
            if (this.totaldata[i].taggedUserCoordinates) {
                taggedUserCoordinates = this.totaldata[i].taggedUserCoordinates.split(',');
                this.totaldata[i].taggedUserCoordinates = taggedUserCoordinates;
            }

            if (usersTagged[0] != 'undefined' && taggedUserCoordinates[0] != null) {
                var lenn = usersTagged.length;
                var tagsCords: any = [];
                for (var j = 0; j < lenn; j++) {
                    var userCords = {
                        name: usersTagged[j],
                        right: 0,
                        top: 0
                    };
                    if (taggedUserCoordinates[j]) {
                        var cordinates = taggedUserCoordinates[j].split('-');
                        userCords.right = cordinates[0];
                        userCords.top = cordinates[1];

                        tagsCords.push(userCords);
                    }
                }
                this.totaldata[i].coords = tagsCords;
            }

            var post = this.totaldata[i].postedOn;
            var poston = Number(post);
            var postdate = new Date(poston);
            var currentdate = new Date();
            var timeDiff = Math.abs(postdate.getTime() - currentdate.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            var diffHrs = Math.round((timeDiff % 86400000) / 3600000);
            var diffMins = Math.round(((timeDiff % 86400000) % 3600000) / 60000);

            if (1 < diffDays) {
                this.totaldata[i].postedOn = diffDays + "d";
            } else if (1 <= diffHrs) {
                this.totaldata[i].postedOn = diffHrs + "h";
            } else {
                this.totaldata[i].postedOn = diffMins + "m";
            }

            this.posts.push(this.totaldata[i]);

        }
        // this.posts = this.totaldata;
    }


    loadmore() {
        // console.log(this.offset);

        this.offset = this.posts.length;

        this._profileService.loadmore(this.offset)
            .subscribe((res) => {
                // var len = res.data[1].length;
                // for (var i = 0; i < len; i++) {
                //     this.posts.push(res.data[1][i]);
                // }

                this.totaldata = res.data[1];
                this.commentfunction();

                this.offset = res.data[1].length || 0;
                if (this.offset >= 20)
                    this.loadmoree = true;
                else
                    this.loadmoree = false;
            });
    }

    timepost(item: any) {
        var postsId = item.postId;
        var followingUsername = this.data.username;
        let link = ['home/homepost', followingUsername, postsId];
        this._router.navigate(link);
    }

    usertagged(i: any) {
        this.posts[i].usertaggedFlagg = true;
    }
    falseusertagged(i: any) {
        this.posts[i].usertaggedFlagg = false;
    }

    usertaggedname(tagged: any): void {
        // alert(item.postId);
        var personname = tagged.name;
        var username = localStorage.getItem('username');
        if (username == personname) {
            this._router.navigate(['home/profile']);
        }
        else {
            let link = ['home/person', personname];
            this._router.navigate(link);
        }
    }


    logout() {
        // this._profileService.logout();
        var token = localStorage.removeItem('authToken');
        var username = localStorage.removeItem('username');
        this._router.navigate(['login']);
    }

    activeitem(id: any) {
        // alert(id);
        jQuery('.item').removeClass("active");
        jQuery('#' + id + 'w').addClass("active");

    }



    memberprofile(item: any): void {
        // alert(item.postsId);
        var personname = item.username;
        var username = localStorage.getItem('username');
        if (username == personname) {
            this._router.navigate(['home/profile']);
        }
        else {
            let link = ['home/person', personname];
            this._router.navigate(link);
        }
        // let link = ['home/person', item.username];
        // this._router.navigate(link);
    }
    memberprofilee(comment: any): void {
        // alert(item.postsId);
        var personname = comment.commentedByUser;
        var username = localStorage.getItem('username');
        if (username == personname) {
            this._router.navigate(['home/profile']);
        }
        else {
            let link = ['home/person', personname];
            this._router.navigate(link);
        }
        // let link = ['home/person', comment[0]];
        // this._router.navigate(link);
    }
    membercaption(caption: any): void {
        var hashtagname = caption.split('#');
        //   console.log(hashtagname[1]);        
        let link = ['home/personcaption', hashtagname[1]];
        this._router.navigate(link);
    }

    membercaptionn(comment: any): void {
        var hashtagname = comment[1].split('#');
        //   console.log(hashtagname[1]);        
        let link = ['home/personcaption', hashtagname[1].replace(" ", "")];
        this._router.navigate(link);

    }

    memberprofilecaption(comment: any): void {
        // var hashtagname = comment[1].split('@');
        //   console.log(hashtagname[1]);        
        // let link = ['home/personcaption', hashtagname[1].replace(" ","")];
        // this._router.navigate(link); 

        var personname = comment[1].split('@');
        var username = localStorage.getItem('username');
        if (username == personname[1]) {
            this._router.navigate(['home/profile']);
        }
        else {
            let link = ['home/person', personname[1].replace(" ", "")];
            this._router.navigate(link);
        }

    }

    memberprofilecaptionn(caption: any): void {
        var personname = caption.split('@');
        var username = localStorage.getItem('username');
        if (username == personname[1]) {
            this._router.navigate(['home/profile']);
        }
        else {
            let link = ['home/person', personname[1].replace(" ", "")];
            this._router.navigate(link);
        }

    }
    // websitelink(data:any){
    //     alert(data.websiteUrl);
    //     let link = [data.websiteUrl];
    //      this._router.navigate(link);

    // }

    commentdelete(comment: any, id: any, postsType: any, i: number, k: number): void {
        //  console.log(comment[0]+" ss "+comment[1]+" id "+id+" postsType "+postsType+" i "+i);
        postsType = postsType.toString();
        this.commnentdetails = ({ username: comment.commentedByUser, message: comment.commentBody, commentId: comment.commentId, id: id, postsType: postsType, i: i, k: k });
    }

    commentmodaldelete(): void {
        //  console.log(this.commnentdetails);

        var commentlist = this.commnentdetails;
        var commenttext = commentlist.message;
        // var hashtag_regexp = /<a href=.*?>(.*?)<\/a>/;                
        // var comment_text = commenttext.replace(hashtag_regexp, '$1');

        // var hashtag_regexp = /<a href=.*?>(.*?)<\/a>/;                
        // var comment_textt = comment_text.replace(hashtag_regexp, '$1');
        var hashtag_regexp = /<a[^>]*>([^<]+)<\/a>/g;
        var comment_text = commenttext.replace(hashtag_regexp, '$1');

        // console.log(this.posts[commentlist.i].comments[commentlist.k]);     
        this.posts[commentlist.i].commentData.splice([commentlist.k], 1);
        this._profileService.userdeletecomment({ username: commentlist.username, message: comment_text, commentId: commentlist.commentId, id: commentlist.id, postsType: commentlist.postsType })
            .subscribe();
    }

    likeStatus(liked: any): void {
        var personname = liked;
        // alert(personname);
        var username = localStorage.getItem('username');
        if (username == personname) {
            this._router.navigate(['home/profile']);
        }
        else {
            let link = ['home/person', personname];
            this._router.navigate(link);
        }
    }


    likedoubleClick(id: any, postsType: any, i: number) {
        // alert(id+'aa'+'bb'+postsType+'cc'+i);
        if (this.posts[i].likeStatus == 0) {
            this.posts[i].likeheartFlagg = true;
            var username = localStorage.getItem('username');
            this.posts[i].postLikedBy.unshift(username);
            this.posts[i].likeStatus = 1;
            this.posts[i].likes += 1;
            this._profileService.userlike(id, postsType)
                .subscribe();
            setTimeout(() => {
                this.posts[i].likeheartFlagg = false;
            }, 500);
        }
    }

    likeactive(id: any, postsType: any, i: number) {
        // alert(id);
        var username = localStorage.getItem('username');
        this.posts[i].postLikedBy.unshift(username);
        this.posts[i].likeStatus = 1;
        this.posts[i].likes += 1;
        this._profileService.userlike(id, postsType)
            .subscribe();
    }
    likedeactive(id: any, postsType: any, i: number) {
        var username = localStorage.getItem('username');
        var array = this.posts[i].postLikedBy;
        var index = array.indexOf(username);
        if (index > -1) {
            array.splice(index, 1);
        }
        this.posts[i].likeStatus = 0;
        this.posts[i].likes -= 1;
        this._profileService.userunlike(id, postsType)
            .subscribe();

    }

    following(item: any, i: number) {
        // alert(i+'ll'+username+'ff'+followFlag);
        var username = item.username;
        var memberPrivateFlag = item.memberPrivateFlag;
        this.data2[i].loaderFlag = true;
        if (memberPrivateFlag == 1) {
            setTimeout(() => {
                this.data2[i].userFollowRequestStatus = 0;
            }, 500);
            this._profileService.following(username)
                .subscribe();
            setTimeout(() => {
                this.data2[i].loaderFlag = false;
            }, 500);
        }
        if (memberPrivateFlag != 1) {
            setTimeout(() => {
                this.data2[i].userFollowRequestStatus = 1;
            }, 500);
            this._profileService.following(username)
                .subscribe();
            setTimeout(() => {
                this.data2[i].loaderFlag = false;
            }, 500);
        }
    }

    follow(item: any, i: number) {
        var username = item.username;
        this.data2[i].loaderFlag = true;
        setTimeout(() => {
            this.data2[i].userFollowRequestStatus = null;
        }, 500);
        this._profileService.follow(username)
            .subscribe();
        setTimeout(() => {
            this.data2[i].loaderFlag = false;
        }, 500);
    }

    followingflag(item: any, i: number) {
        var username = item.username;
        var memberPrivateFlag = item.memberPrivateFlag;
        // alert(i+'ll'+username+'ff'+followFlag);
        this.data1[i].loaderFlag = true;
        if (memberPrivateFlag == 1) {
            setTimeout(() => {
                this.data1[i].userFollowRequestStatus = 0;
            }, 500);
            this._profileService.following(username)
                .subscribe();
            setTimeout(() => {
                this.data1[i].loaderFlag = false;
            }, 500);
        }
        if (memberPrivateFlag != 1) {
            setTimeout(() => {
                this.data1[i].userFollowRequestStatus = 1;
            }, 500);
            this._profileService.following(username)
                .subscribe();
            setTimeout(() => {
                this.data1[i].loaderFlag = false;
            }, 500);
        }
    }

    followflag(item: any, i: number) {
        var username = item.username;
        this.data1[i].loaderFlag = true;
        setTimeout(() => {
            this.data1[i].userFollowRequestStatus = null;
        }, 500);
        this._profileService.follow(username)
            .subscribe();
        setTimeout(() => {
            this.data1[i].loaderFlag = false;
        }, 500);
    }

    usercommentSubmit(value: any, id: any, postsType: any, i: number) {
        // console.log('you submitted value:', value, id, postsType, i);
        postsType = postsType.toString();
        var username = localStorage.getItem('username');

        var commenttext = value;
        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
        var comment_text = commenttext.replace(
            hashtag_regexp,
            '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>'
        );
        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
        var comment_textt = comment_text.replace(
            hashtag_regexp1,
            '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>'
        );
        if (value.length > 0) {
            // this.posts[i].comments.push([username, comment_textt]);

            this._profileService.usercomment({ message: value, id: id, postsType: postsType })
                .subscribe((res) => {
                    this.submitComment = res.data;
                    this.posts[i].commentData.push(this.submitComment[0].commentData[0]);
                    this.hashtagFunction();
                });
        }
    }

    removePhoto() {
        jQuery(".suggestion_image").attr("src", "");
        this.data.profilePicUrl = "";
        jQuery(".modal").modal("hide");
      }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Home/profile/profile.component.ts
 **/